export default __webpack_public_path__ + "static/media/sale6.9c414291.png";